import DOMPurify from 'isomorphic-dompurify';

import Section from '@/components/app/product/components/@shared/section';
import Props from '@/components/app/product/components/content/details/type';

export default function Details({ content, ...props }: Props) {
  const descriptionContent = DOMPurify.sanitize(content);
  return (
    <Section
      id='productDescriptionSection'
      expandable
      className='mx-0 px-[15px] py-[25px] text-[#424244] md:max-h-[1200px] md:p-[38px]'
    >
      <article
        className='custom-inner-html'
        dangerouslySetInnerHTML={{ __html: descriptionContent }}
      />
    </Section>
  );
}
